module.exports = __webpack_public_path__ + "img/eye.92657085.svg";